import React from 'react';
import { Text } from '@web-for-marketing/react-ui';
import { blogCardStyle as classes } from './BlogCardStyle';

interface PillProps {
    category: string;
    categoryLink: string;
    className?: string;
}

export function CategoryPill({ category, categoryLink, className }: PillProps): JSX.Element {
    return (
        <div css={classes.category} className={className}>
            <Text variant='body3' component='a' href={categoryLink} color='secondary'>
                {category}
            </Text>
        </div>
    );
}
